<template>
    <base-button class="btn--white"> 
        <slot></slot>
    </base-button>
</template>

<script>
import BaseButton from './base_button';
export default {
    components: {
        'base-button': BaseButton
    }
};
</script>